// Loader.jsx
import React from 'react';

const Loader = ({ 
  size = 'medium', 
  overlay = false, 
  message = 'Loading...',
  fullScreen = false,
  type = 'brand' // 'brand', 'white', 'light'
}) => {
  const sizeMap = {
    small: 'spinner-border-sm',
    medium: '',
    large: 'spinner-border-lg'
  };

  const typeMap = {
    brand: 'text-blaze-orange',
    white: 'text-white',
    light: 'text-light-orange'
  };

  const loaderContent = (
    <div className="loader-container">
      <div className={`spinner-border ${sizeMap[size]} ${typeMap[type]}`} role="status">
        <span className="visually-hidden">{message}</span>
      </div>
      {message && <p className={`mt-3 mb-0 ${type === 'white' ? 'text-white' : 'text-muted'}`}>{message}</p>}
    </div>
  );

  if (fullScreen) {
    return (
      <div className="loader-fullscreen">
        {loaderContent}
      </div>
    );
  }

  if (overlay) {
    return (
      <div className="loader-overlay">
        {loaderContent}
      </div>
    );
  }

  return (
    <div className="loader-inline">
      {loaderContent}
    </div>
  );
};

export default Loader;